import { WFCreateStepFilter } from "@/types/WorkflowCreate/workflowCreate"
import { WorkflowTaskFilter } from "@/types/WorkflowCreate/workflowUpdateV2"

export const getFiltersDifference = (
  oldFilters: WorkflowTaskFilter[] | undefined,
  newFilters: WFCreateStepFilter[]
) => {
  const result: WorkflowTaskFilter[] = []

  // Handle existing filters (update or unchanged)
  oldFilters?.forEach(old => {
    const match = newFilters.find(nf => nf.filter === old.filter)
    if (match) {
      // Only push with id if the value changed or unchanged
      if (old.filterValue !== match.filterValue) {
        // Value updated → keep ID
        result.push({
          id: old.id,
          filter: old.filter,
          filterValue: match.filterValue
        })
      } else {
        // Unchanged → just keep as is
        result.push({
          id: old.id,
          filter: old.filter,
          filterValue: old.filterValue
        })
      }
    } else {
      // Not found in new filters → mark for removal
      result.push({
        id: old.id,
        filter: old.filter,
        filterValue: old.filterValue,
        remove: true
      })
    }
  })

  // Handle new filters (no old entry)
  newFilters?.forEach(nf => {
    const alreadyExists = oldFilters?.some(of => of.filter === nf.filter)
    if (!alreadyExists) {
      result.push({
        filter: nf.filter,
        filterValue: nf.filterValue
      })
    }
  })

  return result
}

